import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { GlobalSearchListItemTitleStyled } from './styles/GlobalSearchListItemTitleStyled'
import {
  type GlobalSearchResultTypeEnum,
  GlobalSearchResultTypes,
} from '../../../../../../value-objects/enums'
import { useFormatGlobalSearchResultTypeLabel } from '../../hooks/useFormatGlobalSearchResultTypeLabel'

interface IGlobalSearchListItemTitleProps {
  type: GlobalSearchResultTypeEnum
  id: string
  extraIdentifier?: Nullable<string>
}

export const GlobalSearchListItemTitle = ({
  type,
  id,
  extraIdentifier,
}: IGlobalSearchListItemTitleProps) => {
  const intl = useProcurifyIntl()
  const formatResultTypeLabel = useFormatGlobalSearchResultTypeLabel()

  const usePlainId =
    type === GlobalSearchResultTypes.VENDOR ||
    type === GlobalSearchResultTypes.CATALOG_ITEM

  if (usePlainId) {
    return (
      <GlobalSearchListItemTitleStyled noWrap textEllipsis className='fs-mask'>
        {id}
      </GlobalSearchListItemTitleStyled>
    )
  }

  const label = formatResultTypeLabel(type)
  const title = extraIdentifier
    ? intl.formatMessage(messages.titleWithExtraIdentifier, {
        label,
        id,
        extraIdentifier,
      })
    : intl.formatMessage(messages.titleWithoutExtraIdentifier, { label, id })

  return (
    <GlobalSearchListItemTitleStyled noWrap textEllipsis className='fs-mask'>
      {title}
    </GlobalSearchListItemTitleStyled>
  )
}
